import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { useNavigate } from 'react-router-dom'
import { useRouteData } from '../../RouteDataContext';

/**
 * CommonSupportHome
 * Renders the support home page, provides options for WhatsApp and support queries.
 */
export const CommonSupportHome = () => {
    const navigate = useNavigate()
    const { userData, dashboard } = useRouteData();
    const title = "Hi";
    const encodedTitle = encodeURIComponent(title);
    const whatsappLink = `whatsapp://send?text=${encodedTitle}&phone=${dashboard?.support?.whatsapp}`;
    return (
        <div style={{ backgroundColor: 'white', minHeight: '100vh' }}>
            <div className="col-xl-12 ms-4 me-4 pt-4">
                <div style={{ background: '#FBF6F7', minHeight: '35px', overflow: 'hidden', wordWrap: 'break-word' }} className='border rounded'>
                    <div className='fs-4  m-2'>How can we help you?</div>
                </div>
            </div>
            <div className='d-flex justify-content-center mt-8'>
                <img
                    alt='Support'
                    src={toAbsoluteUrl('/media/images/supprt2.png')}
                    className='img-fluid  '
                    style={{ width: '60%', height: 'auto' }}
                />
            </div>
            <div className='mt-6 pb-6 '>
                <div className="fw-semibold fs-1 pt-4 pb-2 ps-8  mt-4">Support</div>
                <span className='ps-8  fs-4 text-muted'>How can we help you?</span>
            </div>
            <div >
                <div className="row g-5 g-xl-8 ps-6 pe-6  mt-2">
                    <div className="col-6">
                        <a href={whatsappLink} className="card border card-xl-stretch me-2 ms-4 shadow-sm mb-xl-8" >
                            <div className="m-6 d-flex flex-column align-items-center ">
                                <i className="fab fa-whatsapp fa-3x text-success mb-4"></i>
                                <div className="text-gray-900 fw-semibold fs-5">
                                    WhatsApp Us
                                </div>
                            </div>
                        </a>
                    </div>
                    <div className="col-6">
                        <a href={`tel:${dashboard?.support?.phone}`} rel="noopener noreferrer" className="card border card-xl-stretch me-2 ms-4 shadow-sm mb-xl-8" >
                            <div className="m-6 d-flex flex-column align-items-center">
                                <i className="fas fa-headset fa-3x  mb-3" style={{ color: "#2A027B" }}></i>
                                <div className="text-gray-900 fw-semibold fs-5 ">
                                    Call Helpdesk
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="col-12">
                        <div role='button' onClick={() => navigate(`/customer/support-query/${userData?.user?.iirpl_sap_code}`)} className="card border card-xl-stretch me-2 ms-4 shadow-sm mb-xl-8">
                            <div className="m-6 d-flex flex-column align-items-center">
                                <i className="fas fa-question-circle fa-3x text-primary mb-4"></i>
                                <div className="text-gray-900 fw-semibold fs-5">
                                    Raise a Query
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}
